export default __webpack_public_path__ + "static/media/RIGHT-P14-3mm.45ca1663.dwg";